export default "__VITE_ASSET__DhPLQVKv__";